import { computed } from "@ember/object";
import { classNames } from "@ember-decorators/component";
import ComboBoxComponent from "discourse/select-kit/components/combo-box";
import {
  pluginApiIdentifiers,
  selectKitOptions,
} from "discourse/select-kit/components/select-kit";
import { i18n } from "discourse-i18n";
import { HOLIDAY_REGIONS } from "../lib/regions";

@selectKitOptions({
  filterable: true,
  allowAny: false,
  none: "discourse_events.region.select_region",
})
@pluginApiIdentifiers("timezone-input")
@classNames("timezone-input", "region-input")
export default class RegionInput extends ComboBoxComponent {
  allowNoneRegion = false;

  @computed
  get content() {
    const localeNames = {};
    let regions = [];

    this.siteSettings.available_locales.forEach((locale) => {
      localeNames[locale.value] = locale.name;
    });

    if (this.allowNoneRegion === true) {
      regions.push({
        name: i18n("discourse_events.region.none"),
        id: null,
      });
    }

    regions = regions.concat(
      HOLIDAY_REGIONS.map((region) => ({
        name: i18n(`discourse_events.region.names.${region}`),
        id: region,
      })).sort((a, b) => a.name.localeCompare(b.name))
    );
    return regions;
  }
}
